import React from 'react'
import { branch, renderComponent } from 'recompose'
import styled from 'styled-components'
import { Theme } from '@pga/pga-component-library'

export const ErrorPageContainer = styled.div`
  display: flex;
  z-index: 1005;
  ${(props) =>
    props.global &&
    `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.75);  
  `};

  align-items: center;
  justify-content: center;
  min-height: 100vh;

  .center {
    max-width: 50%;
  }
`

export const ErrorBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 999;
  ${(props) =>
    props.global &&
    `
    margin: 40px auto; 
    padding: 50px 25px 25px 25px ;
    width: 400px;
    height: 150px;
    border: 1px solid #ccc; 
  `};

  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  text-align:center;

  @media screen and (max-width: 576px) {
    width: 80%;
  }
  p {
    font-family: ${Theme.fonts.Montserrat};
  }
`

export const ErrorPage = ({ error, ...props }) => (
  <ErrorPageContainer {...props}>
    <div className='center alert alert-danger' role='alert'>
      {error && error.message ? error.message : 'Unknown Error'}
    </div>
  </ErrorPageContainer>
)

export const ErrorBox = ({ ...props }) => (
  <ErrorBoxContainer {...props}>
    <div className='center' role='alert'>
      <p>This Job Is No Longer Available.</p>
      <p><a href='/'>Return To The Job Search</a></p>
    </div>
  </ErrorBoxContainer>
)
const WithErrorScreen = branch((props) => props.error, renderComponent(ErrorPage))

export default WithErrorScreen
